<template>
  <fieldset
    v-if="options?.length > 0"
    :class="['form-builder-radio', {'required': required}]"
    :aria-invalid="!!errorMessage"
    :aria-describedby="`${id}-error`">
    <legend class="size-xs">{{ label }}{{ required ? ' *' : ''}}</legend>
    <div
      v-for="option in options"
      :key="option._uid"
    >
      <label class="custom-radio">
        <input
          :id="prefixId(option.id)"
          :value="option.id"
          :name="id"
          type="radio"
          @change="handleChange"
        />
        <span v-html="option.label" />
      </label>
    </div>
    <p
      v-if="!!errorMessage"
      :id="`${prefixId(id)}-error`"
      role="alert"
      class="form-error"
    >
      {{ errorMessage }}
    </p>
  </fieldset>
</template>

<script setup>
import { useField } from "vee-validate";
import { v4 as uuidv4 } from "uuid";

const props = defineProps({
  options: {
    type: Array,
    required: false,
    default: () => {
      return [];
    },
  },
  label: {
    type: String,
    required: false,
    default: "",
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
  rules: {
    type: [String, Object],
    required: false,
    default: "",
  },
  required: {
    type: Boolean,
    required: false,
  },
});

const uuid = ref(uuidv4());

const rules = computed(() => {
  if (props.rules) return props.rules;
  if (props.required) return "required";
});
const { value: radiosValue, errorMessage } = useField(props.id,rules);
const emit = defineEmits(["isMyself"]);

const prefixId = (value) => {
  return `${uuid.value}-${value}`;
};

const updateCheckedState = (input) => {
  const radios = Array.from(document.querySelectorAll('.form-builder-section fieldset input[type="radio"]'));
  const isChecked = radios.filter((item) => {
    return item.checked == true;
  });
  radiosValue.value = isChecked.length > 0 ? input.value : undefined;
};

const handleChange = (e) => {
  const radioName =  e.target.getAttribute("name");
  const radioValue =  e.target.getAttribute("value");

  updateCheckedState(e.target); 

  if(radioName === "Myself") {
    emit('isMyself', radioValue === "1" ? true : false);
  } 
};
</script>

<style lang="scss" scoped>
fieldset div {
  margin-top: 0.5rem;
}
.custom-radio {
  align-items: start;
  input[type="radio"] {
    margin-top: 0.125rem;
  }
}
</style>
